import { mount } from "@vue/test-utils";
import BranchOffices from "@/components/core/composite/combos/BranchOffices";

describe("BranchOffices component", () => {
  let wrapper;

  const props = {
    placeholder: "placeHolderValue",
    label: "labelValue",
    value: "propValue",
    subhint: "subHintValue",
    validationError: "",
    items: "itemsValue",
    inputMode: "inputMode"
  };

  beforeEach(() => {
    wrapper = mount(BranchOffices, {
      propsData: props
    });
  });

  it("Renders del component BranchOffices", () => {
    expect(wrapper).toBeDefined();
  });
});
